export default __webpack_public_path__ + "static/blogpost-87a52b5935c1577024a00c5c476bfe68.png";